// extracted by mini-css-extract-plugin
export default {"root":"EditListingDescriptionPanel_root__5Z8rU","form":"EditListingDescriptionPanel_form__Y6IUg","title":"EditListingDescriptionPanel_title__xJpTe"};